import { render } from "./FormPasswordReset.vue?vue&type=template&id=3a398e34&scoped=true"
import script from "./FormPasswordReset.vue?vue&type=script&lang=js"
export * from "./FormPasswordReset.vue?vue&type=script&lang=js"

import "@/css/components/form-password-reset.css?vue&type=style&index=0&id=3a398e34&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a398e34"]])

export default __exports__